// extracted by mini-css-extract-plugin
export default {"mobileLayout":"layout_mobileLayout__QIxE9","desktopLayout":"layout_desktopLayout__zkmAo"};